











import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Navbar from './user/Navbar.vue'

@Component({ components: { Navbar } })
export default class User extends Vue {}
